import { IFilter } from "@saleor/components/Filter";
import { FilterOpts } from "@saleor/types";
import { SmopStatusEnum } from "@saleor/types/globalTypes";
import { createOptionsField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum BrandVerticalsFilterKey {
  brandStatus = "brandStatus",
  vertical = "vertical"
}

export interface BrandVerticalsFilterOpts {
  brandStatus: FilterOpts<string[]>;
  vertical: FilterOpts<string[]>;
}

const messages = defineMessages({
  active: {
    defaultMessage: "Active",
    description: "active status"
  },
  brandStatus: {
    defaultMessage: "Status",
    description: "brand status"
  },
  cyberzone: {
    defaultMessage: "Cyberzone",
    description: "cyberzone"
  },
  declined: {
    defaultMessage: "Declined",
    description: "Declined status"
  },
  deleted: {
    defaultMessage: "Deleted",
    description: "Deleted status"
  },
  fb: {
    defaultMessage: "Food and Beverages",
    description: "food and beverages"
  },
  grocery: {
    defaultMessage: "Grocery",
    description: "grocery"
  },
  inactive: {
    defaultMessage: "Inactive",
    description: "inactive status"
  },
  marketplace: {
    defaultMessage: "Marketplace",
    description: "marketplace"
  },
  retail: {
    defaultMessage: "Retail Affiliates",
    description: "retails affiliates"
  },
  reviewed: {
    defaultMessage: "Reviewed",
    description: "Reviewed status"
  },
  vertical: {
    defaultMessage: "Vertical",
    description: "vertical"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: BrandVerticalsFilterOpts
): IFilter<BrandVerticalsFilterKey> {
  return [
    {
      ...createOptionsField(
        BrandVerticalsFilterKey.brandStatus,
        intl.formatMessage(messages.brandStatus),
        opts.brandStatus.value,
        true,
        [
          {
            label: intl.formatMessage(messages.active),
            value: SmopStatusEnum.ACT
          },
          {
            label: intl.formatMessage(messages.inactive),
            value: SmopStatusEnum.INA
          },
          {
            label: intl.formatMessage(messages.deleted),
            value: SmopStatusEnum.DEL
          },
          {
            label: intl.formatMessage(messages.reviewed),
            value: SmopStatusEnum.RVW
          },
          {
            label: intl.formatMessage(messages.declined),
            value: SmopStatusEnum.DCL
          }
        ]
      ),
      active: opts.brandStatus.active
    },
    {
      ...createOptionsField(
        BrandVerticalsFilterKey.vertical,
        intl.formatMessage(messages.vertical),
        opts.vertical.value,
        true,
        [
          {
            label: intl.formatMessage(messages.fb),
            value: intl.formatMessage(messages.fb)
          },
          {
            label: intl.formatMessage(messages.cyberzone),
            value: intl.formatMessage(messages.cyberzone)
          },
          {
            label: intl.formatMessage(messages.grocery),
            value: intl.formatMessage(messages.grocery)
          },
          {
            label: intl.formatMessage(messages.marketplace),
            value: intl.formatMessage(messages.marketplace)
          },
          {
            label: intl.formatMessage(messages.retail),
            value: intl.formatMessage(messages.retail)
          }
        ]
      ),
      active: opts.vertical.active
    }
  ];
}
